import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "cash-float-close"
};
var _hoisted_2 = {
  class: "dialog-footer"
};
import { ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { computed, onUnmounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { clearShallLogout } from "@/utils/vue-helpers/modal";
import { generateReadableId } from "@/utils/helpers/app";
import dayjs from "dayjs";
import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config";
import DeviceModule from "@/store/modules/device";
import { LogLevel, LogService } from "@/services/logging";
import CashFloatModule from "@/store/modules/cash-float";
import BookingModule from "@/store/modules/booking";
import { Currencies } from "@/constants/currency";
import { handleCashTransferSync } from "@/utils/vue-helpers/cash-float";
var formLabelWidth = "140px";
export default /*#__PURE__*/_defineComponent({
  __name: 'CashFloatOpen',
  setup: function setup(__props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _withAsyncContext2, _withAsyncContext3;

      var __temp, __restore, _useI18n, t, dialogFormVisible, isLoading, form, rules, locationsList, hideDialog, openCashfloat, _openCashfloat;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _openCashfloat = function _openCashfloat3() {
                _openCashfloat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var _DeviceModule$deviceI2;

                  var groupId, cashTransferIn, isSynced, dateNow, uid, valueForBackend, cashFloat, memory, mem;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          isLoading.value = true;
                          groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // Add a new CashTransfer of type (IN)

                          cashTransferIn = {
                            _id: dayjs().toISOString(),
                            createdAt: dayjs().toISOString(),
                            amount: Number(form.cashFloatAmount),
                            currency: Currencies.EUR,
                            groupId: Number(groupId),
                            from: form.locationId || null,
                            to: Number((_DeviceModule$deviceI2 = DeviceModule.deviceInfo) === null || _DeviceModule$deviceI2 === void 0 ? void 0 : _DeviceModule$deviceI2.locationId),
                            note: form.message || null,
                            channel: "Smeetz POS"
                          };
                          _context.next = 5;
                          return handleCashTransferSync(cashTransferIn);

                        case 5:
                          isSynced = _context.sent;

                          if (isSynced) {
                            _context.next = 8;
                            break;
                          }

                          return _context.abrupt("return");

                        case 8:
                          dateNow = dayjs().toISOString();
                          uid = generateReadableId();
                          valueForBackend = Number(form.cashFloatAmount) * 100;
                          cashFloat = {
                            seqId: 0,
                            userId: UserModule.userId,
                            posId: null,
                            groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
                            firstPosConfigId: POSConfigModule.selectedConfig ? POSConfigModule.selectedConfig.id : null,
                            startAmounts: {
                              EUR: valueForBackend
                            },
                            amounts: {
                              EUR: valueForBackend
                            },
                            userSwitch: [],
                            closeDate: "",
                            createdAt: dateNow,
                            updatedAt: dateNow,
                            uid: uid,
                            deviceId: DeviceModule.deviceId || null,
                            version: 1
                          };
                          LogService.info("Setting a new cashfloat with uuid ".concat(cashFloat.uid), {
                            params: cashFloat
                          });
                          CashFloatModule.setCashFloat(cashFloat); // //clear the array of unsynched bookings

                          BookingModule.clearAllPendingToSyncBookings(); // // Create first booking to have something on the UI

                          BookingModule.createNewBooking();
                          LogService.info("Created cashfloat with uuid ".concat(cashFloat.uid), {
                            params: cashFloat
                          }); // Now lets log current memory consumption

                          try {
                            if (window.performance && window.performance.memory) {
                              memory = window.performance.memory;
                              mem = {
                                date: dayjs().utc().toISOString(),
                                totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
                                usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
                                jsHeapSizeLimit: memory.jsHeapSizeLimit / (1024 * 1024),
                                domMemory: (memory.totalJSHeapSize - memory.usedJSHeapSize) / (1024 * 1024)
                              };
                              LogService.info("Memory consumption after starting sales", {
                                params: {
                                  memoryConsumption: mem
                                }
                              });
                            }
                          } catch (err) {
                            // Couldn't log memory consumption
                            LogService.info("Error when trying to log memory consumption", {
                              params: {
                                error: err
                              }
                            }, LogLevel.Error);
                          }

                          isLoading.value = false;
                          console.log("hide"); // hideDialog();

                        case 20:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _openCashfloat.apply(this, arguments);
              };

              openCashfloat = function _openCashfloat2() {
                return _openCashfloat.apply(this, arguments);
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              dialogFormVisible = ref(true);
              isLoading = ref(false);
              form = reactive({
                cashFloatAmount: 0,
                message: "",
                locationId: 1
              });
              rules = reactive({
                cashFloatAmount: [{
                  pattern: /^[0-9]*(\.[0-9]{1,2})?$/,
                  message: t("cashfloat.invalid"),
                  trigger: "blur"
                }]
              });
              ;
              _withAsyncContext2 = _withAsyncContext(function () {
                return DeviceModule.fetchLocations();
              }), _withAsyncContext3 = _slicedToArray(_withAsyncContext2, 2), __temp = _withAsyncContext3[0], __restore = _withAsyncContext3[1], _withAsyncContext2;
              _context2.next = 11;
              return __temp;

            case 11:
              __restore();

              locationsList = computed(function () {
                return DeviceModule.locations.filter(function (l) {
                  var _DeviceModule$deviceI;

                  return l.id !== Number((_DeviceModule$deviceI = DeviceModule.deviceInfo) === null || _DeviceModule$deviceI === void 0 ? void 0 : _DeviceModule$deviceI.locationId);
                });
              });

              hideDialog = function hideDialog() {
                ModalModule.setStatus(ModalStatus.Hidden);
              };

              onUnmounted(function () {
                clearShallLogout();
              });
              return _context2.abrupt("return", function (_ctx, _cache) {
                var _component_el_input = _resolveComponent("el-input");

                var _component_el_form_item = _resolveComponent("el-form-item");

                var _component_el_option = _resolveComponent("el-option");

                var _component_el_select = _resolveComponent("el-select");

                var _component_el_form = _resolveComponent("el-form");

                var _component_el_button = _resolveComponent("el-button");

                var _component_el_dialog = _resolveComponent("el-dialog");

                return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
                  modelValue: dialogFormVisible.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                    return dialogFormVisible.value = $event;
                  }),
                  title: _ctx.$t('cashfloat.message'),
                  "show-close": false
                }, {
                  footer: _withCtx(function () {
                    return [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
                      onClick: hideDialog,
                      class: "booking-button"
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
                      }),
                      _: 1
                    }), _createVNode(_component_el_button, {
                      type: "primary",
                      loading: isLoading.value,
                      onClick: _cache[3] || (_cache[3] = function ($event) {
                        return openCashfloat();
                      }),
                      class: "booking-button"
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
                      }),
                      _: 1
                    }, 8, ["loading"])])];
                  }),
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_form, {
                      model: form,
                      "label-position": "top",
                      rules: rules
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_el_form_item, {
                          label: _ctx.$t('cashfloat.title'),
                          "label-width": formLabelWidth
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_el_input, {
                              type: "number",
                              modelValue: form.cashFloatAmount,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                                return form.cashFloatAmount = $event;
                              }),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])];
                          }),
                          _: 1
                        }, 8, ["label"]), _createVNode(_component_el_form_item, {
                          label: "location",
                          "label-width": formLabelWidth
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_el_select, {
                              modelValue: form.locationId,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                                return form.locationId = $event;
                              }),
                              placeholder: _ctx.$t('location')
                            }, {
                              default: _withCtx(function () {
                                return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsList.value, function (item) {
                                  return _openBlock(), _createBlock(_component_el_option, {
                                    key: Number(item.id),
                                    label: String(item.name),
                                    value: Number(item.id)
                                  }, null, 8, ["label", "value"]);
                                }), 128))];
                              }),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])];
                          }),
                          _: 1
                        }), _createVNode(_component_el_form_item, {
                          label: _ctx.$t('receipt.message'),
                          "label-width": formLabelWidth
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_el_input, {
                              type: "textarea",
                              modelValue: form.message,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                                return form.message = $event;
                              }),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])];
                          }),
                          _: 1
                        }, 8, ["label"])];
                      }),
                      _: 1
                    }, 8, ["model", "rules"])];
                  }),
                  _: 1
                }, 8, ["modelValue", "title"])]);
              });

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});